"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerConnection = void 0;
const tslib_1 = require("tslib");
const eventemitter3_1 = tslib_1.__importDefault(require("eventemitter3"));
const types_1 = require("@json-rpc-tools/types");
const rpc_connection_1 = tslib_1.__importDefault(require("@walletconnect/rpc-connection"));
class SignerConnection extends types_1.IJsonRpcConnection {
    constructor(opts) {
        super();
        this.events = new eventemitter3_1.default();
        this.connector = this.register(opts);
    }
    get connected() {
        return typeof this.connector !== "undefined" && this.connector.connected;
    }
    get connecting() {
        return false;
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    open() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                if (typeof this.connector === "undefined") {
                    this.connector = this.register(this.opts);
                }
                if (this.connector.wc === null) {
                    throw new Error("Connector missing or invalid");
                }
                this.connector.wc.on("disconnect", () => {
                    reject();
                });
                this.connector.wc.on("connect", () => {
                    this.onOpen(this.connector);
                    resolve();
                });
                this.connector.create();
            });
        });
    }
    close() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (typeof this.connector === "undefined") {
                return;
            }
            if (this.connector.wc === null) {
                throw new Error("Connector missing or invalid");
            }
            yield this.connector.wc.killSession();
            this.onClose();
        });
    }
    send(payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (typeof this.connector === "undefined") {
                this.connector = this.register(this.opts);
            }
            this.connector.sendPayload(payload).then((res) => this.events.emit("payload", res));
        });
    }
    register(opts) {
        return new rpc_connection_1.default(opts);
    }
    onOpen(connector) {
        if (connector) {
            this.connector = connector;
        }
        this.events.emit("open");
    }
    onClose() {
        if (this.connector) {
            this.connector = undefined;
        }
        this.events.emit("close");
    }
}
exports.SignerConnection = SignerConnection;
exports.default = SignerConnection;
//# sourceMappingURL=index.js.map